import { TimelineParty } from '../slices/marketplace/timeline/models/enums/timeline-party.enum';

export const canUseDaqiDataTools = (party?: TimelineParty | null): boolean =>
    party === TimelineParty.VetValue || party === TimelineParty.Broker;
